const API_URL = process.env.REACT_APP_BACKEND_URL;

let clerkPromise = null;

export const fetchClerkConfig = async () => {
  try {
    const res = await fetch(`${API_URL}/api/auth/clerk/config`);
    if (!res.ok) return { enabled: false };
    return await res.json();
  } catch {
    return { enabled: false };
  }
};

// Loads Clerk's browser SDK from the Clerk frontend API (no npm dependency) and returns window.Clerk.
export const loadClerk = () => {
  if (clerkPromise) return clerkPromise;
  clerkPromise = (async () => {
    const config = await fetchClerkConfig();
    if (!config.enabled || !config.publishable_key || !config.frontend_api) {
      throw new Error('Google sign-in is not available');
    }
    if (!window.Clerk) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://${config.frontend_api}/npm/@clerk/clerk-js@5/dist/clerk.browser.js`;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.setAttribute('data-clerk-publishable-key', config.publishable_key);
        script.onload = resolve;
        script.onerror = () => reject(new Error('Could not load Google sign-in'));
        document.head.appendChild(script);
      });
    }
    await window.Clerk.load();
    return window.Clerk;
  })();
  clerkPromise.catch(() => { clerkPromise = null; });
  return clerkPromise;
};

export const SSO_RETURN_PATH = '/login?sso=1';
